import { apiClient } from '@/core/api/client';

export type GuestSessionResponse = {
  token: string;
  sid: string;
  expiresIn: string;
};

/**
 * Exchanges a solved invisible-reCAPTCHA token for a short-lived guest session
 * token. Verified fail-closed server-side before the token is issued.
 */
export const mintGuestSession = async (
  recaptchaToken: string,
): Promise<GuestSessionResponse> => {
  const { data } = await apiClient.post<GuestSessionResponse>(
    '/care-engine/guest-session',
    { recaptchaToken },
  );
  return data;
};
